import * as React from 'react';

var _path, _path2, _path3, _path4;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgSgp = function SvgSgp(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#EEE",
        d: "M23.154 17.539A2.46 2.46 0 0 1 20.692 20H3.462A2.46 2.46 0 0 1 1 17.538V6.462A2.46 2.46 0 0 1 3.462 4h17.23a2.46 2.46 0 0 1 2.462 2.462z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#ED2939",
        d: "M23.154 12V6.462A2.46 2.46 0 0 0 20.692 4H3.462A2.46 2.46 0 0 0 1 6.462V12z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M4.692 8c0-1.59 1-2.922 2.345-3.283a3.4 3.4 0 0 0-.806-.101 3.385 3.385 0 1 0 0 6.769c.278 0 .547-.037.806-.101C5.692 10.922 4.692 9.59 4.692 8"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#EEE",
        d: "m8.385 5.23.138.426h.447l-.362.263.139.425-.362-.263-.362.263.139-.425-.362-.263h.447zM7.155 9.54l.138.425h.446l-.361.262.138.426-.362-.263-.362.263.139-.425-.362-.263h.447zm2.46 0 .14.425h.446l-.362.262.139.426-.362-.263-.362.263.138-.425-.361-.263h.446zM6.54 7.077l.138.425h.447l-.362.263.139.425-.362-.263-.362.263.138-.425-.361-.263H6.4zm3.692 0 .139.425h.446l-.362.263.139.425-.362-.263-.362.263.139-.425-.362-.263h.447z"
    })));
};

export { SvgSgp as ReactComponent };
//# sourceMappingURL=SGP.svg.es.js.map
